<app-mobile-filter (clearFilters)="onClearFilters()" (close)="onClose()">
  <ng-container content>
    <ion-col
      size="12"
      class="ion-no-padding"
    >
      <ion-item
        lines="full"
        (click)="showStatusOptions = !showStatusOptions"
      >
        <ion-label>
          {{ 'RENTAL.STATUS.STATUS' | translate }}
        </ion-label>
        <ion-icon
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showStatusOptions ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-item>
    </ion-col>
    <ion-col
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showStatusOptions ? 'active' : 'inactive'"
    >
      <ion-list>
        <ion-radio-group [value]="rentalServ.getCurrentStatus().length > 0 ? rentalServ.getCurrentStatus(): 'ALL'" (ionChange)="onStatusChange($event)">
          <ion-item
            lines="none"
            *ngFor="let status of statusOptions"
          >
            <ion-label>
              {{status.name}}
            </ion-label>
            <ion-radio value="{{status.id}}"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </ion-col>
  </ng-container>
  <ng-container button> 
    {{rentalServ.filteredElementsLength}}
  </ng-container>
</app-mobile-filter>
